import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '.carousel-inner-item-container',
  standalone: false,
})
export class CarouselInnerItemContainerDirective {}
